export let price = (e)=>{
    return typeof e=='number'?e.toFixed(2) : parseFloat(e).toFixed(2)
}